// ChangePasswordDialog.jsx
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  
  Grid,
  
} from '@mui/material';
import axiosApi from '../Utils/axiosApi';

const ChangePassword = ({ open, onClose }) => {
  const [form, setForm] = useState({
    userName: '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  
const userName = sessionStorage.getItem("userName")
const userId = sessionStorage.getItem("userId")
useEffect(() => {
    if (open) {
      setForm(prev => ({ ...prev, userName: userName || '' }));
    }
  }, [open, userName]);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    if (!form.currentPassword || !form.newPassword || !form.confirmPassword) {
      setError('All fields are required');
      return false;
    }
    if (form.newPassword !== form.confirmPassword) {
      setError('New Password and Confirm Password must match');
      return false;
    }
    return true;
  };

  
  
  const handleSubmit = async () => {
  setError('');
  setSuccess('');

  if (!validateForm()) return;

  try {
    await axiosApi.post('/userManagement/updatePassword', {
      userId: userId,
      userName: form.userName,
      currentPassword: form.currentPassword,
      newPassword: form.newPassword,
    });

    setSuccess(`${userName} Password changed successfully`);
    setError('');
    setForm(prev => ({
      ...prev,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    }));
  } catch (err) {
    setError('Failed to change password. Please try again.');
    console.error("Error processing Company:", err?.response?.data || err.message);
    setSuccess('');
  }
};



  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Change Password</DialogTitle>
      <DialogContent dividers>
       
{/* SUCCESS OR ERROR BANNER */}
      {(success || error) && (
        <div
          style={{
            backgroundColor: success ? '#d4edda' : '#f8d7da',
            color: success ? '#155724' : '#721c24',
            border: `1px solid ${success ? '#c3e6cb' : '#f5c6cb'}`,
            padding: '10px 20px',
            borderRadius: '8px',
            marginBottom: '20px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
        >
          {success || error}
        </div>
      )}
	  
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12}>
            <TextField
              label="Username"
              name="userName"
              value={form.userName}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Current Password"
              name="currentPassword"
              type="password"
              value={form.currentPassword}
              onChange={handleChange}
              fullWidth
              size="small"
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="New Password"
              name="newPassword"
              type="password"
              value={form.newPassword}
              onChange={handleChange}
              fullWidth
              size="small"
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Confirm Password"
              name="confirmPassword"
              type="password"
              value={form.confirmPassword}
              onChange={handleChange}
              fullWidth
              size="small"
              required
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Change
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePassword;
